import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ThankYouSkeleton = (): JSX.Element => (
  <Box width={[320, 400]} pt={[2, 8]} pb={[2, 8]} mx={[2, 'auto']} color="text.primary" textAlign="center">
    <Skeleton height={32} />
    <Skeleton height={32} />
    <Skeleton height={32} width="50%" />
    <Box mt={10}>
      <Skeleton variant="rectangular" height={120} />
    </Box>
  </Box>
);

export default ThankYouSkeleton;
